import React, { Component } from "react";
import GridView from "../Grid/GridView";
import ChildDetail from "../ChildDetail/ChildDetail";
import ChildSearch from "./ChildSearch";

class ViewChooser extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      renderShowMore,
      resetShowMore,
      resetGridCalc,
      calculateGrid,
      gridVars,
      gridVarsReceived,
      setGridWasActive,
      searchMethodSelector,
      setSelectedValue,
      lastSearchKey,
      lastSearchKeyObj,
      descriptorsReceived,
      resetFiltersDisabled,
      enableClearAll,
      updatelastSearchKeyStatus,
      setToolTip,
      changeView,
      device,
      showMore,
      handleHistory,
      descriptorIndex,
      descriptorIndexArray,
      childId,
      handleBackButton,
      sponsorshipMonthlyPrice,
      backLink,
      singleChildView,
      handleChildDetailClick,
      fireAnalyticsEvents
    } = this.props;

    const searchDisplay = this.props.appConfigs.settings.searchDisplay;

    if (singleChildView === false && searchDisplay === 'hidden') {
      return (
        <div>
          <GridView
            changeView={handleChildDetailClick}
            device={device}
            {...this.props}
            showMore={showMore}
            calculateGrid={calculateGrid}
            resetGridCalc={resetGridCalc}
            gridVars={gridVars}
            gridVarsReceived={gridVarsReceived}
            handleHistory={handleHistory}
            setGridWasActive={setGridWasActive}
            lastSearchKey={lastSearchKey}
            lastSearchKeyObj={lastSearchKeyObj}
            descriptorsReceived={descriptorsReceived}
            descriptorIndex={descriptorIndex}
            descriptorIndexArray={descriptorIndexArray}
            enableClearAll={enableClearAll}
            updatelastSearchKeyStatus={updatelastSearchKeyStatus}
          />
        </div>
      );
    } else if (singleChildView === false) {
      return (
        <div>
          <ChildSearch
            device={device}
            {...this.props}
            {...this.state}
            renderShowMore={renderShowMore}
            resetShowMore={resetShowMore}
            resetGridCalc={resetGridCalc}
            calculateGrid={calculateGrid}
            searchMethodSelector={searchMethodSelector}
            setSelectedValue={setSelectedValue}
            lastSearchKey={lastSearchKey}
            resetFiltersDisabled={resetFiltersDisabled}
            enableClearAll={enableClearAll}
            updatelastSearchKeyStatus={updatelastSearchKeyStatus}
            setToolTip={setToolTip}
          />
          <GridView
            changeView={handleChildDetailClick}
            device={device}
            {...this.props}
            showMore={showMore}
            calculateGrid={calculateGrid}
            resetGridCalc={resetGridCalc}
            gridVars={gridVars}
            gridVarsReceived={gridVarsReceived}
            handleHistory={handleHistory}
            setGridWasActive={setGridWasActive}
            lastSearchKey={lastSearchKey}
            lastSearchKeyObj={lastSearchKeyObj}
            descriptorsReceived={descriptorsReceived}
            descriptorIndex={descriptorIndex}
            descriptorIndexArray={descriptorIndexArray}
            enableClearAll={enableClearAll}
            updatelastSearchKeyStatus={updatelastSearchKeyStatus}
          />
        </div>
      );
    } else {
      return (
        <div>
          <ChildDetail
            {...this.props}
            childId={childId}
            device={device}
            handleBackButton={handleBackButton}
            price={sponsorshipMonthlyPrice}
            calculateGrid={calculateGrid}
            resetGridCalc={resetGridCalc}
            gridVars={gridVars}
            gridVarsReceived={gridVarsReceived}
            backLink={backLink}
            setGridWasActive={setGridWasActive}
            descriptorsReceived={descriptorsReceived}
            descriptorIndex={descriptorIndex}
            fireAnalyticsEvents={fireAnalyticsEvents}
          />
        </div>
      );
    }
  }
}
export default ViewChooser;
